import { formatInTimeZone } from 'date-fns-tz'

/**
 * A sign-up slot's time range, in the SCHOOL's timezone.
 *
 * These rows used to call `new Date(...).toLocaleString()` with no zone, i.e.
 * the VIEWER's device zone — the same defect #2149 fixed for event start times
 * (a Miami 11:30am event reading as 6:30am elsewhere). A volunteer slot is a
 * time you physically show up for, so the device zone is never the right
 * answer; under SSR (UTC on Vercel) it also disagreed with the hydrated client.
 *
 * Falls back to UTC when no zone is on file, matching `formatEventDate` and the
 * admin write path so the surfaces cannot diverge. An end time alone would
 * render as a range from nothing, so the dash is emitted only when there is a
 * start to hang it off.
 *
 * Lives here rather than in `rsvp-form-client.tsx` so the fix is unit-testable
 * without mounting the form — and so adding it does not shift that file's long
 * functions down, which the changed-code complexity gate attributes line-wise.
 */
export function slotTimeLine(
  tier: { slotStartsAt?: string | null; slotEndsAt?: string | null },
  schoolTimezone: string | null | undefined
): string {
  const tz = schoolTimezone && schoolTimezone.trim() ? schoolTimezone : 'UTC'
  const start = tier.slotStartsAt ? formatInTimeZone(new Date(tier.slotStartsAt), tz, 'EEE, MMM d · h:mm a') : ''
  const end = tier.slotEndsAt ? formatInTimeZone(new Date(tier.slotEndsAt), tz, 'h:mm a') : ''
  if (start && end) return `${start} – ${end}`
  return start || end
}
